<template>
  <ProductDisplay
    v-if="hasProductRecommendations"
    title="You May Also Like"
    color="white"
    class="product-recommendations"
  >
    <Carousel>
      <div
        v-for="(productRecc, index) in productRecommendations"
        :key="productRecc.id"
        class="slide"
      >
        <ProductCardHelper
          v-slot="{ primaryMedia, secondaryMedia }"
          :product="productRecc"
          :image-type="getImageType(index)"
        >
          <ProductCard
            :product="productRecc"
            :media="primaryMedia"
            :hover-media="secondaryMedia"
          />
        </ProductCardHelper>
      </div>
    </Carousel>
  </ProductDisplay>
</template>

<script>
import productRecommendations from "@/graphql/queries/ProductRecommendations.gql";
import ProductCard from "@/components/ProductCard.vue";
import ProductCardHelper from "@/components/product-card/ProductCardHelper.vue";
import Carousel from "@/components/Carousel.vue";
import ProductDisplay from "@/components/product-display/ProductDisplay.vue";

import { reccsImageSequence } from "@/helpers/imageSequences.js";
import { mapState } from "vuex";

export default {
  name: "ProductRecommendations",
  components: {
    Carousel,
    ProductCard,
    ProductDisplay,
    ProductCardHelper,
  },
  computed: {
    ...mapState("product", ["product"]),
    hasProductRecommendations() {
      return !!this.productRecommendations?.length;
    },
  },
  methods: {
    getImageType(index) {
      return reccsImageSequence[index % reccsImageSequence.length];
    },
  },
  apollo: {
    productRecommendations: {
      query: productRecommendations,
      variables() {
        return {
          productId: this.product.id,
        };
      },
      result({ data }) {
        window.productRecommendations = data.productRecommendations;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.price, .title) {
  color: $color-black;
}
</style>
